<template>
    <div class="row items-stretch">
        <div
            class="cursor-pointer col-4 col-sm-3 col-md-2 col-lg-1"
            v-for="(item, index) in categoryList"
            :key="index"
        >
            <q-card
                class="full-height no-border-radius"
                bordered
                @click="onOpenCategory(item)"
                flat
            >
                <q-card-section>
                    <q-img
                        basic
                        v-if="item.logoUrl"
                        contain
                        height="53px"
                        :src="item.logoUrl"
                    />
                </q-card-section>
                <q-card-section class="q-pt-none">
                    <div class="row justify-center text-center">
                        {{ item.name }}
                    </div>
                </q-card-section>
            </q-card>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
import useCategoryList from "@/mixins/useCategoryList";
export default {
    name: "CatalogGrid",
    mixins: [useCategoryList],
    data() {
        return {
            categoryList: [],
        };
    },
    created() {
        this.loadCategoryList().then((result) => {
            console.log(result);
            this.categoryList = result;
        });
    },
    methods: {
        onOpenCategory(category) {
            console.log("onOpenCategory", category);
            this.$store.commit("allProduct/setL1", category.name);
            this.$router.push({
                name: "AllProduct",
                params: {
                    L1: category.name
                }
            });
        },
    },
};
</script>
